import { createSlice } from '@reduxjs/toolkit';
import { fetchEnquiries } from '../thunks/enquiries';

const initialState = {
  enquiries: [],
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  meta: {},
  pageNumber: 1,
  perPage: 20,
};

export const enquiriesSlice = createSlice({
  name: 'enquiries',
  initialState,
  reducers: {
    setEnquiriesPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
  },
  extraReducers: {
    [fetchEnquiries.pending]: (state) => {
      state.fetching = true;
    },
    [fetchEnquiries.fulfilled]: (state, action) => {
      const { enquiries, meta } = action.payload;
      state.fetching = false;
      state.enquiries = [...state.enquiries, ...enquiries];
      state.meta = meta;
    },
    [fetchEnquiries.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
  },
});

export const { setEnquiriesPageNumber } = enquiriesSlice.actions;
